import React from "react";
import "./contact.css";
import { Link } from "react-router-dom";

function CardContact(props) {
  return (
    <div className="social_media">
      <Link to={{pathname: props.link}} target="_blank">
        <div className="contact_details">
          <h1>
            <img src={props.img} alt="" /> {props.title}
          </h1>
          <p>{props.para}</p>
        </div>
      </Link>
    </div>
  );
}

export default CardContact;
